module.exports = __webpack_public_path__ + "static/assets/75b8bac2584541c0e536f8bf8c65387e.png";